const groupName = 'Badging';
export const badgingSystemPermissions = {
    'manage-badge-templates': {
        group: groupName,
        label: 'Edit Badge Templates',
    },
    'manage-revoked-badge-reasons': {
        group: groupName,
        label: 'Edit Revoked Badge Reasons',
    },
    'manage-badges': {
        group: groupName,
        label: 'Manage Badges',
    },
    'manage-account-badges': {
        group: groupName,
        label: 'Manage Account Badges',
    },
    'revoke-account-badges': {
        group: groupName,
        label: 'Revoke Account Badges',
    },
};
